module.exports = __webpack_public_path__ + "static/media/ChevronLeft.8f0a869d.svg";